import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { BONUS_TOTAL, bonuses } from '../data/content';
export function BonusesSection() {
  return <section aria-labelledby="bonos" className="bg-mist" data-id="element-27" data-mp="gxq6fntr12oh">
      <div className="mx-auto max-w-3xl px-4 py-4 sm:py-8" data-id="element-28" data-mp="vtxn4e5y7lz0">
        <SectionHeader id="bonos" title="5 Bonos incluidos" description="Y además recibes 5 recursos prácticos — GRATIS con tu compra." data-id="element-29" data-mp="qtt7srgs0xad" />
        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-30" data-mp="14rhrvx30s0ed">
          {bonuses.map((b, i) => <li key={b.title} className={`flex flex-col rounded-lg border-2 border-dashed border-brand/40 bg-white p-2.5 sm:p-3 ${i === bonuses.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-31" data-mp="zu7v1wdawmgi" data-mpi={i}>
              <p className="self-start rounded bg-alert px-1.5 py-0.5 font-condensed text-[0.72rem] font-bold uppercase text-white" data-id="element-32" data-mp="1njam1uttrrno">
                Bono {i + 1} — Gratis
              </p>
              <h3 className="mt-1 font-condensed text-[0.95rem] font-bold leading-tight text-navy" data-id="element-33" data-mp="3pqttoki7txeu">{b.title}</h3>
              <p className="mt-0.5 text-[0.8rem] leading-snug text-navy/75 sm:text-sm" data-id="element-34" data-mp="3tr5h251yqbu0">{b.desc}</p>
              <p className="mt-auto pt-1 text-xs font-semibold text-navy/70" data-id="element-35" data-mp="2lcllw5i91n9">
                Valor:{' '}
                <span className="font-numeric text-base font-normal tracking-wide text-navy line-through decoration-alert decoration-2" data-id="element-36" data-mp="7lqjwmhb0x83">
                  {b.value}
                </span>
              </p>
            </li>)}
        </ul>
        <div className="mt-2 rounded-lg border-2 border-energy bg-navy p-2.5 text-center" data-id="element-37" data-mp="gj0wqc9rsuf4">
          <p className="font-display text-sm font-extrabold text-white sm:text-base" data-id="element-38" data-mp="le6ss3wvzpgx">
            💰 Valor total de los 5 bonos:{' '}
            <span className="font-numeric text-xl font-normal tracking-wide line-through decoration-alert decoration-2" data-id="element-39" data-mp="vate0tt4kijh">
              {BONUS_TOTAL}
            </span>
          </p>
          <p className="font-display text-sm font-extrabold text-energy" data-id="element-40" data-mp="al8nezksfzeu">🔥 Hoy los 5 están incluidos gratis.</p>
        </div>
      </div>
    </section>;
}